export enum ReferralSourceInfoHelp {
  SignedRelease = 'Signed Release',
}

export enum ReferralReasonHelp {
  Capta = 'CAPTA',
}
